import copy from "copy-to-clipboard";

/**
 * Копирование текста в буфер обмена.
 *
 * Сначала Clipboard API: copy-to-clipboard выделяет текст во временном элементе вне
 * модального окна, а focus trap MUI Dialog забирает фокус обратно, и в части
 * десктопных браузеров копирование молча не срабатывает. execCommand оставлен
 * запасным путём для небезопасного контекста и старых браузеров.
 *
 * @returns {Promise<boolean>} удалось ли скопировать
 */
export default async function copyText(text) {
  if (!text) return false;

  if (
    typeof navigator !== "undefined" &&
    navigator.clipboard?.writeText &&
    typeof window !== "undefined" &&
    window.isSecureContext
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // нет разрешения или документ не в фокусе: пробуем старый способ
    }
  }

  try {
    return copy(text, { format: "text/plain" });
  } catch (err) {
    return false;
  }
}
